export default [
     {
          path: '/teacher',
          name: 'Teacher',
          component: () => import("@/views/Page/Teacher/Teacher.vue"),
           meta: {
               title: '#Default# | Teacher',
          },
     }
];


